import React from "react";
import { Img, staticFile } from "remotion";

export interface InGameShowcaseStageProps {
  screenshotSrc: string;
  gameTag?: string;
  glowColor?: string;
  sweepProgress?: number;
  width?: number;
  height?: number;
  borderRadius?: number;
  borderColor?: string;
}

export const InGameShowcaseStage: React.FC<InGameShowcaseStageProps> = ({
  screenshotSrc,
  gameTag = "IN-GAME MLBB SHOWCASE",
  glowColor = "rgba(93, 63, 211, 0.4)",
  sweepProgress = 0,
  width = 860,
  height = 640,
  borderRadius = 38,
  borderColor = "#5D3FD3",
}) => {
  return (
    <div
      style={{
        position: "relative",
        width,
        height,
        backgroundColor: "rgba(255, 255, 255, 0.94)",
        backdropFilter: "blur(24px) saturate(180%)",
        borderRadius,
        border: `2.5px solid ${borderColor}`,
        boxShadow: `0 35px 90px ${glowColor}, 0 10px 30px rgba(0,0,0,0.06)`,
        transformStyle: "preserve-3d",
        transform: "translateZ(0px)",
        overflow: "visible",
      }}
    >
      {/* Specular Light Sweep Stripe across card surface */}
      <div
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          width: 140,
          left: `${sweepProgress}%`,
          background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.85), transparent)",
          transform: "skewX(-25deg)",
          pointerEvents: "none",
          borderRadius,
        }}
      />

      {/* Inner Real Gameplay Viewport Window */}
      <div
        style={{
          position: "absolute",
          inset: 16,
          borderRadius: borderRadius - 10,
          backgroundColor: "#0B041E",
          overflow: "hidden",
          transform: "translateZ(10px)",
          boxShadow: "inset 0 2px 20px rgba(0, 0, 0, 0.4)",
        }}
      >
        {/* Authentic In-Game Gameplay Screenshot */}
        <Img
          src={staticFile(screenshotSrc)}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center 30%",
            filter: "contrast(1.05) saturate(1.1)",
          }}
        />

        {/* Edge Glow */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            boxShadow: `inset 0 0 45px ${glowColor}, inset 0 0 20px rgba(0, 240, 255, 0.25)`,
            pointerEvents: "none",
          }}
        />

        {/* Game Tag Badge */}
        <div
          style={{
            position: "absolute",
            top: 18,
            left: 20,
            display: "flex",
            alignItems: "center",
            gap: 8,
            backgroundColor: "rgba(18, 10, 46, 0.85)",
            backdropFilter: "blur(8px)",
            padding: "6px 14px",
            borderRadius: 14,
            border: "1px solid rgba(255, 255, 255, 0.2)",
          }}
        >
          <div style={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: "#00F0FF", boxShadow: "0 0 8px #00F0FF" }} />
          <span style={{ fontFamily: "'Chakra Petch', sans-serif", fontSize: 13, fontWeight: 700, color: "#FFFFFF", letterSpacing: "0.06em" }}>
            {gameTag}
          </span>
        </div>
      </div>
    </div>
  );
};
